import { type IUpdateTabletPayload } from 'types/payloads/tablet.payload.types';
import BaseAPI from './base.api';

export default class TabletAPI extends BaseAPI {
  update = async (tabletId: string, payload: IUpdateTabletPayload) => {
    const response = await this.API.patch(`tablet/${tabletId}`, payload);
    return response.data;
  };

  unassociatedTabletGetAll = async () => {
    const response = await this.API.get('tablet/unassociated');
    return response.data;
  };

  getAllTablets = async () => {
    const response = await this.API.get('tablet');
    return response.data;
  };
}
